RivalIQ.apps.Site.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const stageDetails = App.enums.stageDetails;

    views.ContactModal = Marionette.View.extend({
        events: {
            'submit': 'submissionHandler',
            'click #contactMeSubmit': 'submissionHandler',
            'click a[data-stage]': 'stageTransitionHandler',
            'shown.bs.modal': 'modalShown',
            'show.bs.modal': 'modalShow',
            'hidden.bs.modal': 'modalHidden',
            'click .x-close': 'close'
        },
        ui: {
            firstName: '#contact_first_name',
            lastName: '#contact_last_name',
            email: '#contact_email',
            phone: '#contact_phone',
            company: '#contact_company',
            title: '#contact_title',
            organizationTypeInput: '#contact_organization_type',
            organizationTypeContainer: '#organizationType',
            form: 'form',
            submissionConfirmation: '.submission-confirmation-container',
            requiredMsg: '.x-required-msg',
            error: '.error-container',
            submitButton: '#contactMeSubmit',
            scheduleButton: '#scheduleButton',
            closeButton: '.x-close',
            heading: '.modal-header',
            scheduling: '.scheduling-container',
            footer: '.modal-footer',
            modalDialog: '.modal-dialog'
        },
        initialize: function () {
            const me = this;
            _.bindAll(me, ['formSubmit', 'modalShown', 'validate', 'playedVideoDemo']);
            this.contactType = 'vip';
            this.plan = null;
            this.useOrganizationType = false;

            // because we are not templating this view, the ui hash doesn't get turned into jquery selectors.
            _.each(me.ui, function (value, key) {

                me.ui[key] = me.$(value);
            });

        },
        setType: function (contactType) {
            const me = this;
            me.contactType = contactType;

            // set this in once place
            if (me.contactType === 'vip' || me.contactType === 'demo') {
                me.useOrganizationType = false;
            } else {
                me.useOrganizationType = true;
            }

        },
        modalShown: function () {
            this.$('#contact_email').focus();
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ViewedContactUsForm);
        },
        modalShow: function () {
            const me = this;
            me.ui.organizationTypeContainer.toggle(me.useOrganizationType);

        },
        modalHidden: function () {
            const me = this;

            // invoke stage-specific hide behavior
            stageDetails[me.schedulingStage].modalHiddenBehavior(me);

            // reset modal size if it has been enlarged
            me.ui.modalDialog.removeClass('modal-lg');

            // set up the form to be shown again
            me.ui.error.hide();
            me.ui.form.show();
            me.ui.heading.show();
            me.ui.requiredMsg.show();
            me.ui.closeButton.removeClass('btn-primary');
            $('form input').val('');
        },
        show: function () {
            const me = this;

            if (me.contactType === 'demo') {
                me.ui.scheduleButton.show();
            } else {
                me.ui.submitButton.show();
            }

            me.schedulingStage = 'contactForm';
            me.$('#errorDiv').hide();
            me.$('#errorString').html('');
            me.$('#errorStringLink').hide();
            me.$('#email').val('');

            me.$el.modal('show');
        },
        stageTransitionHandler: function (e) {

            const me = this;
            me.transitionToStage($(e.currentTarget).attr('data-stage'));
        },
        transitionToStage: function (schedulingStage) {

            const me = this;
            me.schedulingStage = schedulingStage;

            const transitionToBehavior = stageDetails[me.schedulingStage].transitionToBehavior;
            if (_.isFunction(transitionToBehavior)) {

                transitionToBehavior(me);
            }
        },
        submissionHandler: function (e) {

            // we're handling our own submission
            e.preventDefault();
            const me = this;

            if (me.validate()) {

                if (me.contactType === 'demo') {

                    // if the contact request is for a demo, we want to transition
                    // to scheduling when the user presses enter
                    me.transitionToStage('scheduling');
                } else {

                    me.formSubmit();
                }
            }
        },
        formSubmit: function () {

            const contactMe = new App.models.ContactMe();
            const me = this;
            const organizationType = (me.useOrganizationType ? me.ui.organizationTypeInput.val() : me.contactType);
            contactMe.save({
                first_name: me.ui.firstName.val(),
                last_name: me.ui.lastName.val(),
                email: me.ui.email.val(),
                phone_number: me.ui.phone.val(),
                company: me.ui.company.val(),
                title: me.ui.title.val(),
                contact_type: organizationType,
                contact_location_data: me.getOption('contactLocationData')(),
                scheduling_method: stageDetails[me.schedulingStage].schedulingMethod
            }, {
                success: function () {

                    RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.SubmittedContactUsForm);
                    me.formSubmissionSuccess();
                },
                error: function () {

                    me.formSubmissionError();
                }
            });
        },
        formSubmissionSuccess: function () {

            const me = this;

            const submissionSuccessBehavior = stageDetails[me.schedulingStage].submissionSuccessBehavior;
            if (_.isFunction(submissionSuccessBehavior)) {

                submissionSuccessBehavior(me);
            }
        },
        formSubmissionError: function () {

            const me = this;

            const submissionErrorBehavior = stageDetails[me.schedulingStage].submissionErrorBehavior;
            if (_.isFunction(submissionErrorBehavior)) {

                submissionErrorBehavior(me);
            }
        },
        validate: function () {
            const me = this;
            const elemsToValidate = [
                me.ui.firstName,
                me.ui.lastName,
                me.ui.phone,
                me.ui.company,
                me.ui.title
            ];
            let result = true;

            elemsToValidate.forEach(function (elem) {
                if (!elem.val()) {
                    result = false;
                    elem.closest('.form-group').addClass('has-error');
                } else {
                    elem.closest('.form-group').removeClass('has-error');
                }
            });
            // now validate the org type
            if (me.useOrganizationType) {
                // if not VIP and you haven't picked startup vs. non-profit
                if (Number(me.ui.organizationTypeInput.val()) === -1) {
                    result = false;
                    me.ui.organizationTypeContainer.addClass('has-error');
                } else {
                    me.ui.organizationTypeContainer.removeClass('has-error');
                }
            }

            // validate email separately since we also want to check if it's a valid email address
            const email = me.ui.email.val();
            if (!email || !me.getOption('validEmailAddress')(email)) {
                result = false;
                me.ui.email.closest('.form-group').addClass('has-error');
            }

            return result;

        },
        close: function () {
            this.$el.modal('hide');
        },
        playedVideoDemo: function () {

            const me = this;

            // enlarge the modal so that the video can be seen more easily
            me.ui.modalDialog.addClass('modal-lg');

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.PlayedVideoDemo);

            // remove click event since we won't need it again and don't want it to be fired again
            me.$el.off('click', me.playedVideoDemo);
        }
    });
});
